import CustomStore from "devextreme/data/custom_store";
import {getList} from "./Base.js";

const getGridData = (mRoute,params={}) => {

    let getstore = new CustomStore({
        key: "id",
        load: function (loadOptions) {
          var parameters = {};
          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          parameters.filter = JSON.stringify(loadOptions.filter);
          parameters.skip = loadOptions.skip;
          parameters.take = loadOptions.take;
          parameters.page = (parameters.skip + parameters.take) / parameters.take;
          let merged = {...parameters, ...params};
          var config = {
            params: merged,
          };
          let listurl =  mRoute; 
          console.log("GRID LIST URL",listurl)
          return axios
            .get(listurl, config)
            .then((response) => {
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        //update: function (key,values) {

          //console.log("update",key);
          /* var config = {
            data: values,
          };
          let listurl =  mRoute+"/"+key; 
          return axios
            .put(listurl, config)
            .then((response) => {
              return response.data;
            })
            .catch(() => {
              throw "Update Error";
            }); */
        //},
        //remove: function (key) {
          /* return axios
            .delete(mRoute + "/" + key)
            .then((response) => {
              return response.data;
            })
            .catch(() => {
              throw "Data Loading Error";
            }); */
        //}
    });

    return getstore;    
};

const getHeaders = (modulekey,slug) => {
  let url ="/"+slug+"/"+modulekey+"/headers";
 
  let params = {    
  };
  return getList(url,params);
}

const getQuickCreateDef = (modulekey,slug) => {

  let url ="/"+slug+"/"+modulekey+"/quickcreatedef";
  let params = {    
  };
  return getList(url,params);
}






export {getGridData,getHeaders,getQuickCreateDef}